import DatePicker from "./src/picker/date-picker";
import doCoveringLogicWithElement from "@/assets/js/override_element";

/* istanbul ignore next */
DatePicker.install = function install(Vue) {
  Vue.component(
    DatePicker.name,
    doCoveringLogicWithElement({ DatePicker }).DatePicker
  );
};
export default DatePicker;
